import React, {useState,useEffect} from "react";
import Profile from "../../entities/ProfilePage";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import AuthService from "../../api/AuthService";
import { subscriptionService, planService } from "../../api";
import { useAlert } from "../../context/AlertContext";
import currencySymbolMap from "currency-symbol-map";
import { formatDate } from "../../utils/DateFormat";

const normalizeListResponse = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.data?.subscriptions)) return response.data.subscriptions;
  if (Array.isArray(response?.result?.subscriptions)) return response.result.subscriptions;
  if (Array.isArray(response?.result)) return response.result;
  return [];
};

const normalizeId = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  return value._id || value.id || "";
};

const formatDisplayDate = (value) => {
  if (!value) return "Not Available";
  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) return String(value);
  return formatDate(value);
};

const formatPlanRate = (price, currency) => {
  const amount = Number(price);
  if (!Number.isFinite(amount)) return "Not Available";

  const currencyCode = String(currency || "").trim().toUpperCase();
  const formattedAmount = Number.isInteger(amount) ? String(amount) : amount.toFixed(2);

  if (!currencyCode) return formattedAmount;

  const symbol = currencySymbolMap(currencyCode);
  if (symbol) return `${symbol}${formattedAmount}`;
  return `${currencyCode} ${formattedAmount}`;
};

const defaultPlanDetails = {
  subscriptionId: "",
  planName: "Not Available",
  planPrice: null,
  planRate: "Not Available",
  expiryDate: "Not Available",
  billingCycle: "Not Available",
  isActive: false,
  previousTransactions: [],
  inviteLink: "",
  autoRenew: false,
  autoRenewStatus: "",
  hasPaymentAuthorization: false,
};

const ProfilePage = () => {
  const [data, setData] = useState(null);
  const [imgUrl, setimgUrl] = useState(null);
  const [departmentData, setDepartmentData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [planDetails, setPlanDetails] = useState(defaultPlanDetails);
  const [companyList, setCompanyList] = useState([]);
  const [opens, setOpens] = useState(false);
  const [imageUploading, setImageUploading] = useState(false);

  const [loading, setLoading] = useState();
  const { showAlert } = useAlert();
  const role = localStorage.getItem("role") || "";
  const shouldShowPlanManagement =
    role !== "SuperAdmin" && role !== "Employee";

  const buildInviteLink = () => {
    return "https://payroll.cablinks.org/";
  };


  useEffect(() => {
    getProfileView();
    getDepartment();
    if (shouldShowPlanManagement) {
      getPlanDetails();
    }
    getCompanyList();
  },[])
  const getProfileView = async() =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getProfileView();
      if (result?.success) { 
        setData(result?.data);
    
        LoaderHelper.loaderStatus(false);
            
        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleUrl = async (data) => {
    setImageUploading(true);
    try {
      const result = await AuthService.handleSingleImgUrl(data);
      if (result?.success && result?.data?.[0]) {
        const uploadedImageUrl = result.data[0];
        setimgUrl(uploadedImageUrl);
        return uploadedImageUrl;
      }

      setimgUrl(null);
      showAlert(result?.message || "Unable to upload image", "error");
      return null;
    } catch (error) {
      setimgUrl(null);
      showAlert(error?.message || "Error uploading image", "error");
      return null;
    } finally {
      setImageUploading(false);
    }
  };

  const handleDeleteProfileImage = () => {
    setimgUrl("");
  };

  const CountryCode = async(country) =>{
    console.log(country,"country")
    try {
      const result = await AuthService.getCountry(country);
      if (result?.success) {
         
        setCountryData(result?.data);
      }else {
        setCountryData("");
        setLoading(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      setLoading(false);
      // console.error("Error occurred:", error);
    }
  };
  const getDepartment = async() =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDepartment();
      if (result?.success) { 
        setDepartmentData(result?.data?.position);

        LoaderHelper.loaderStatus(false);
        
        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };

  const getPlanDetails = async () => {
    try {
      const [subscriptionResult, plansResult] = await Promise.all([
        subscriptionService.list(),
        planService.list(),
      ]);

      const subscriptions = normalizeListResponse(subscriptionResult);
      const plans = normalizeListResponse(plansResult);
      if (!subscriptions.length && !plans.length) {
        setPlanDetails(defaultPlanDetails);
        return;
      }

      const plansMap = plans.reduce((acc, plan) => {
        acc[plan?._id || plan?.id] = plan;
        return acc;
      }, {});

      const companyId = String(
        localStorage.getItem("companyId") || localStorage.getItem("id") || ""
      ).trim();
      const adminId = String(
        localStorage.getItem("userId") || localStorage.getItem("employeeId") || ""
      ).trim();

      const sortedSubscriptions = [...subscriptions].sort(
        (a, b) =>
          new Date(b?.updatedAt || b?.createdAt || 0) -
          new Date(a?.updatedAt || a?.createdAt || 0)
      );

      const matchedSubscription = sortedSubscriptions.find((subscription) => {
          const subscriptionCompanyId = normalizeId(subscription?.companyId);
          const subscriptionAdminId = normalizeId(subscription?.adminId);
          return (
            (companyId && subscriptionCompanyId === companyId) ||
            (adminId && subscriptionAdminId === adminId)
          );
        }) || sortedSubscriptions[0] || null;

      const planId = normalizeId(matchedSubscription?.planId);
      const planFromSubscription =
        matchedSubscription?.planId && typeof matchedSubscription?.planId === "object"
          ? matchedSubscription.planId
          : {};
      const planFromSubscriptionId = plansMap[planId] || {};
      const currentPlanFromList = plans.find((plan) => plan?.currentPlan === true) || {};
      const activePlan =
        currentPlanFromList?._id ||
        currentPlanFromList?.id ||
        currentPlanFromList?.planName
          ? currentPlanFromList
          : planFromSubscriptionId;

      // Plan prices are per country, so the plan list (fetched without a country)
      // carries no flat price. The subscription stores the price actually charged.
      const resolvedPrice =
        activePlan?.price ??
        planFromSubscription?.price ??
        planFromSubscriptionId?.price ??
        matchedSubscription?.planPrice;

      const resolvedCurrency =
        activePlan?.currency ||
        planFromSubscription?.currency ||
        planFromSubscriptionId?.currency ||
        matchedSubscription?.planCurrency;

      const expiryDateRaw =
        matchedSubscription?.nextBillingDate ||
        matchedSubscription?.expiryDate ||
        matchedSubscription?.endDate ||
        matchedSubscription?.validTill ||
        matchedSubscription?.date;

      const transactionHistory = Array.isArray(matchedSubscription?.transactionHistory)
        ? matchedSubscription.transactionHistory
        : [];

      const previousTransactions = transactionHistory
        .slice()
        .sort(
          (a, b) =>
            new Date(b?.date || b?.createdAt || 0) -
            new Date(a?.date || a?.createdAt || 0)
        )
        .map((transaction, index) => {
          const txPlanName =
            transaction?.planId?.planName ||
            planFromSubscription?.planName ||
            activePlan?.planName ||
            "Plan";
          const txAmount = Number(transaction?.amount);
          const txCurrency = String(transaction?.currency || "").trim().toUpperCase();
          const amountText = Number.isFinite(txAmount)
            ? `${txCurrency ? `${txCurrency} ` : ""}${txAmount}`
            : "N/A";

          return {
            id: normalizeId(transaction?._id) || `${index}-${transaction?.date || ""}`,
            planName: txPlanName,
            date: formatDisplayDate(transaction?.date || transaction?.createdAt),
            status: transaction?.status || "pending",
            amount: amountText,
          };
        });

      setPlanDetails({
        subscriptionId: normalizeId(matchedSubscription),
        planName:
          activePlan?.planName ||
          planFromSubscription?.planName ||
          planFromSubscriptionId?.planName ||
          defaultPlanDetails.planName,
        planPrice: Number.isFinite(Number(resolvedPrice)) ? Number(resolvedPrice) : null,
        planRate: formatPlanRate(resolvedPrice, resolvedCurrency),
        expiryDate: formatDisplayDate(expiryDateRaw),
        billingCycle:
          activePlan?.billingCycle ||
          planFromSubscription?.billingCycle ||
          planFromSubscriptionId?.billingCycle ||
          defaultPlanDetails.billingCycle,
        isActive:
          activePlan?.isActive !== false &&
          (matchedSubscription ? matchedSubscription?.isActive !== false : true),
        previousTransactions,
        inviteLink: buildInviteLink(),
        autoRenew: matchedSubscription?.autoRenew === true,
        autoRenewStatus: matchedSubscription?.autoRenewStatus || "",
        hasPaymentAuthorization: Boolean(
          matchedSubscription?.authorization?.authorizationCode
        ),
      });
    } catch (error) {
      setPlanDetails({
        ...defaultPlanDetails,
        inviteLink: buildInviteLink(),
      });
    }
  };

  const handleRegister = async (data, user, resetCallback) => {
    if (imageUploading) {
      showAlert("Please wait for the image upload to finish", "error");
      return;
    }

    setLoading(true);
    try {
      const result = await AuthService.editProfile(data,imgUrl,user);

      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        getProfileView();
        if (resetCallback) resetCallback();
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      console.log(error, "error----------------")
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };
  const handleTransfer = async (email) => {

    setLoading(true);
    try {
      const result = await AuthService.handleTransfer(email);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  const getCompanyList = async () => {
    try {
      const result = await AuthService.getCompantList();
      if (result?.success) {
        setCompanyList(Array.isArray(result?.data) ? result.data : []);
      }
    } catch (error) {
      // Company list is optional on profile page.
    }
  };

  const handleDeleteCompany = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteCompany(id);
      if (result?.success === true) {
        setOpens(false);
        showAlert(result?.message, "success");
        if (result?.data?.is_matched) {
          localStorage.clear();
          window.location.href = "/";
        } else {
          getCompanyList();
        }
      } else {
        showAlert(result?.message, "error");
      }
    } catch (error) {
      showAlert(error?.message || "Unable to delete company", "error");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  return data ? (
    <Profile userData={data}  registerEmployee={handleRegister} handleUrl={handleUrl} data={countryData} CountryCode={CountryCode} departmentData={departmentData} loading={loading}
      imageUploading={imageUploading}
      handleTransfer={handleTransfer} planDetails={planDetails}
      companyList={companyList} opens={opens} setOpens={setOpens} handleDeleteCompany={handleDeleteCompany}
      handleDeleteProfileImage={handleDeleteProfileImage}
      showAlert={showAlert}/>
  ) : null;


}

export default ProfilePage;
